export enum Urgency {
    NORMAL = 'NORMAL',
    URGENT = 'EILT'
}

export enum NRL {
    UNKNOWN = 'Labor nicht erkannt',
    KL_Vibrio = 'KL-Vibrio',
    NRL_VTEC = 'NRL-VTEC',
    L_Bacillus = 'L-Bacillus',
    NRL_AR = 'NRL-AR',
    NRL_AR_Kleb = 'NRL-AR-Kleb',
    NRL_Campy = 'NRL-Campy',
    NRL_Staph = 'NRL-Staph',
    NRL_Listeria = 'NRL-Listeria',
    NRL_Salm = 'NRL-Salm',
    L_Clostridium = 'L-Clostridium',
    KL_Yersinia = 'KL-Yersinia'
}
